$('img').each(function(i, element) {
  if ($(element).data('showimage')) {
    var url = $(this).data('showimage')
    var defaultUrl = $(this).attr('src')
    $(this).hover(function() {
      $(this).attr('src', url)
    })
    $(this).mouseleave(function() {
      $(this).attr('src', defaultUrl)
    })
  }
})



// WEBPACK FOOTER //
// ./src/browser/oldJs/lib/utilities.js